/**
 * Inicialización del sistema de temas
 * Este archivo se ejecuta ANTES de que se renderice cualquier componente
 * para garantizar que los colores del cliente estén disponibles desde el inicio
 */
import { themeRegistry } from './utils/themeRegistry';
import { generateClientColors } from './utils/themeHelpers';
import { updateColorsWithClientTheme } from './styles/_colors';
import { getRuntimeEnv } from './utils/runtimeEnv';

// Inicializar colores del cliente de forma síncrona
const clientName = getRuntimeEnv('REACT_APP_CLIENT_NAME');

if (clientName) {
  console.log('🎨 Inicializando colores del cliente:', clientName);
  
  const clientTheme = themeRegistry.getTheme(clientName);
  
  if (clientTheme) {
    const clientColors = generateClientColors(clientTheme);
    updateColorsWithClientTheme(clientColors);
    
    console.log('✅ Colores del cliente aplicados:', clientTheme.name);
    console.log('   Primary:', clientTheme.primaryColor);
    console.log('   Secondary:', clientTheme.secondaryColor);
  }
} else {
  console.log('ℹ️ Usando colores por defecto');
}
